import React from 'react';

import formatPrice from '../../../../../helpers/formatPrice';

import Typography from '../../../../../components/_ui/_blocks/Typography/Typography';
import Tag from '../../../../../components/_ui/_blocks/Tag/Tag';

interface DeliveryProps {
    amountRemainingForFreeDelivery: number;
    minimumDeliveryCost: number;
}

const DeliveryRow = ({ amountRemainingForFreeDelivery, minimumDeliveryCost }: DeliveryProps) => {
    const freeDeliveryDescription = amountRemainingForFreeDelivery <= 0
        ? 'Your order qualifies for free delivery!'
        : `Spend ${formatPrice(amountRemainingForFreeDelivery)} more for free delivery`;

    return (
        <li>
            <div>
                <Typography as="div" size="090">Delivery</Typography>
                <Typography as="div" size="080" color="quiet">{freeDeliveryDescription}</Typography>
            </div>
            {amountRemainingForFreeDelivery <= 0 ? (
                <Tag size="medium" color="info">Free</Tag>
            ) : formatPrice(minimumDeliveryCost)}
        </li>
    );
}

export default DeliveryRow;
